<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding" v-else-if="loaded" > 
        
        
        <div class="row" >
            <div class="col-10" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search" class="search-input atlass-input-borderless" />
                    <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                </b-input-group>
            </div>
            <div class="col-2 text-right" >
                <a @click="fModalOpen" class="btn btn-primary btn-sm" > <font-awesome-icon icon="plus" /> Add New </a>
            </div>
        </div>
        
        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{ enabled: true, externalQuery: filter }"
            styleClass="vgt-table atlass-datatable"
            :pagination-options="{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            @on-row-click="routeRow"
             >
        </vue-good-table>
        
        <modal modalData="" :modalState="modalState" modalComponent="organizationNew" modalClass="narrower" ></modal>

    </div>
</template>

<script>
import modal from '@/components/modal.vue'  
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'

export default{
    name: "organizations",
    components:{
        modal
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: 'NAME',
                    field: 'name'
                    //field: this.returnName,
                },
                {
                    label: 'OWNER',
                    field: 'name',
                    field: this.returnOwner,
                },
                {
                    label: 'STATUS',
                    field: this.renderStatus,
                },
                {
                    label: 'CREATED AT',
                    field: this.returnDate,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            rows: [],
            loaded: false,
            modalState: false,
            newOrg:{
                name: '',
                status: 0,
                subscription:{},
                owner: {
                    firstname:'',
                    lastname:'',
                    email: '',
                    password: '',
                },
            },
            subscriptions:[],
            subOptions: [ { value: 0, text: '-- Select subscription --' }, ],
            statusOptions:[
                { value: 0, text: 'Inactive' },
                { value: 1, text: 'Active' },
            ],
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        this.get_organizations();
        
    },
    computed: {
    },
    methods: {
        fModalOpen( data ){
            this.modalState = true;
        },
        get_organizations(){
            
            this.loaded = false;
            
            const db = firebase.firestore();
            db.collection('organizations')
                .get()
                .then(snap => {
                    const results = [];
                    snap.forEach(doc => {
                        //console.log(doc.data())
                        let item = doc.data()
                        item.id = doc.id
                        results.push( item );
                    });
                
                    results.sort((a, b) => b.datetime - a.datetime);
                
                    this.rows = results;
                    this.loaded = true;
                });

        
        },
        returnOwner(a){
            return a.owner.email;
        },
        returnDate(a){
            return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm' )
        },
        renderStatus(a){
            var r;
            
            if( a.status == 1 ){
                r = 'Active';
            }else if( a.status == 0 ){
                r = 'Inactive';
            }else if( a.status == 2 ){
                r = 'Blocked';
            }else if( a.status == 3 ){
                r = 'Manually blocked';
            }
            
            return r;
        },
        routeRow(params){
            let id = params.row.id;
            this.$router.push({
                name: 'Organization',
                params: { ID: id }
            }); 
        },
    }
}
</script>

<style lang="scss" >
    @import '../../assets/css/atlass-datatable.scss';
    @import '../../assets/css/atlass-modal.scss';
</style>


// WEBPACK FOOTER //
// src/templates/admin/Organizations.vue